import { OPERATIONS_DELIVERY } from '@/data/operations';
import { ServiceDelivery } from '../service/ServiceDelivery';

export const HowWeDeliver = () => (
  <ServiceDelivery
    data={OPERATIONS_DELIVERY}
    accent="#FFB800"
    index="03"
    testidPrefix="operations"
  />
);
